var CONFUSEDCMS = CONFUSEDCMS || {},
    CONFUSEDPETROLPRICES = CONFUSEDPETROLPRICES || {};
CONFUSEDPETROLPRICES.MiEvents = CONFUSEDPETROLPRICES.MiEvents || {};

(function (ns, $) {
    'use strict';

    CONFUSEDPETROLPRICES.initEventDecorator = function () {

        // create event decorator
        var e = CONFUSEDCMS.eventDecorator;

        var functionNames = {
            miPageEvent: 'CONFUSEDCMS.eventDecorator.events.miPageEvent'
        };

        // add events to definition list
        e.EventDefinitionList.Add(new e.EventDefinition('#sortPricesByCheapest', 'click', functionNames.miPageEvent, [{ EventType: 'petrolprices:filter:sortpricesbycheapest', EventInfo: { Control: 'petrol-prices-filter' } }]));
        e.EventDefinitionList.Add(new e.EventDefinition('#sortPricesByDistance', 'click', functionNames.miPageEvent, [{ EventType: 'petrolprices:filter:sortpricesbydistance', EventInfo: { Control: 'petrol-prices-filter' } }]));
        e.EventDefinitionList.Add(new e.EventDefinition('#closeMap', 'click', functionNames.miPageEvent, [{ EventType: 'petrolprices:directions:hide', EventInfo: { Control: 'petrol-prices-directions' } }]));
        e.EventDefinitionList.Add(new e.EventDefinition('#petrolPricesLoginButton', 'click', functionNames.miPageEvent, [{ EventType: 'petrolprices:login:clicked', EventInfo: { Control: 'petrol-prices-login' } }]));
        e.EventDefinitionList.Add(new e.EventDefinition('#petrolPricesRegisterButton', 'click', functionNames.miPageEvent, [{ EventType: 'petrolprices:register:clicked', EventInfo: { Control: 'petrol-prices-login' } }]));

        // process all events in the definition list
        e.EventDefinitionList.ProcessAll();
    };

    CONFUSEDPETROLPRICES.submitPageEvent = function (eventInfo) {
        CONFUSEDCMS.services.MiService().pageEvent(eventInfo);
    };

}(CONFUSEDPETROLPRICES.MiEvents, jQuery));